import { render, staticRenderFns } from "./VehicleTypeFilter.vue?vue&type=template&id=5fe4961c&scoped=true"
import script from "./VehicleTypeFilter.vue?vue&type=script&lang=js"
export * from "./VehicleTypeFilter.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeFilter.vue?vue&type=style&index=0&id=5fe4961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe4961c",
  null
  
)

export default component.exports